var _defs, _path, _g, _g2, _g3, _g4, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNz = function SvgNz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "nz_svg__b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nz_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-.3v.5l1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.2.3 0-.1l1-.2z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__a",
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__a",
    transform: "rotate(72 0 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__a",
    transform: "rotate(-72 0 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__a",
    transform: "scale(-1 1)rotate(72)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00247d",
    fillRule: "evenodd",
    d: "M0 0h640v480H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-111 36.1)scale(.66825)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__b",
    width: "100%",
    height: "100%",
    fill: "#fff",
    transform: "translate(900 120)scale(45.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__b",
    width: "100%",
    height: "100%",
    fill: "#cc142b",
    transform: "matrix(30 0 0 30 900 120)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82 525.2 114.6)scale(.66825)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__b",
    width: "100%",
    height: "100%",
    fill: "#fff",
    transform: "rotate(-82 519 -457.7)scale(40.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__b",
    width: "100%",
    height: "100%",
    fill: "#cc142b",
    transform: "rotate(-82 519 -457.7)scale(25)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82 525.2 114.6)scale(.66825)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__b",
    width: "100%",
    height: "100%",
    fill: "#fff",
    transform: "rotate(-82 668.6 -327.7)scale(45.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__b",
    width: "100%",
    height: "100%",
    fill: "#cc142b",
    transform: "rotate(-82 668.6 -327.7)scale(30)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-111 36.1)scale(.66825)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__b",
    width: "100%",
    height: "100%",
    fill: "#fff",
    transform: "translate(900 480)scale(50.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__b",
    width: "100%",
    height: "100%",
    fill: "#cc142b",
    transform: "matrix(35 0 0 35 900 480)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h320v240H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M120.5 0v240h80V0zM0 80v80h320V80z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
  })));
};
export default SvgNz;